import React,{useEffect,useState} from "react";
import withFirst from "../../hoc/withFirst";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"
import { subscribe,getCountryMessage } from "../../../../../api";
import Alert from "../../../../components/alert";
import Cache from "../../../../../utils/cache";
import { useIntl,FormattedMessage } from "react-intl";
import { Iconfont } from "../../../../components/icon/iconfont";
import { BigButton } from "../../../../components/button";
import { useSelector,useDispatch } from "react-redux";
import { action_fetch_current_user } from "../../../../../store/actions/global";

const Item = withFirst(props =>{
    useStyles(classes);
    const {innerRef,message} = props;
    const intl = useIntl()
    const dispatch = useDispatch();

    const [email, setEmail] = useState();
    const [loading, setLoading] = useState(false)

    const handleSub = async evt => {
        evt.preventDefault()
        if(!email) return
        setLoading(true)

        const response = await subscribe(email)

        if(response?.code === 200){
            Alert(`${intl.formatMessage({id: 'thanks_subscribe'})} \n ${intl.formatMessage({id: 'thanks_enjoy'})}`)
			setLoading(false);
            dispatch(action_fetch_current_user());
            Cache.set("customerEmail",email,(365*24*60*60)*1000);
        }else{
            alert(response?.result || response)
			setLoading(false)
        }
        
    }

    return (
        <>
            <div ref={innerRef}>
                {
                    message && <div style={{backgroundImage: `url(${message?.imageUrl})`}} className={classes.BottomSubscribe}>
                        <Iconfont onClick={props?.onClose} style={{color: message?.message}} className={classes.Close}>&#xe6af;</Iconfont>
                        <form action="#" className={classes.SubscribeArea} onSubmit={handleSub}>
                            <div className={classes.SubInput}>
                                <input type='email' value={email} placeholder={intl.formatMessage({id: 'email', defaultMessage:'Email'})} onChange={evt => {setEmail(evt.target.value)}}/>
                            </div>
                            <BigButton style={{backgroundColor: message?.color || '#222'}} className={classes.SubBtn} loading={loading}><FormattedMessage id="register" defaultMessage="Register"/></BigButton>
                        </form>
                    </div>
                }
                
            </div>
        </>
    )
})

export default props =>{
    const [message, setMessage] = useState();
    const pageGlobal = useSelector(state => state.global)

    const initLoad = async () =>{
        if(!message && !Cache.get('index-bottom-subscribe')){
            const message = await getCountryMessage('M1319').then(data => data?.result?.fixedDiscount).catch(e => null)
            setMessage(message)
        }
    }

    return (
        <React.Fragment>
            {
                (!pageGlobal?.user || !pageGlobal?.user.id) && <Item initLoad={initLoad} message={message} onClose={() =>{
                    Cache.set('index-bottom-subscribe',true);
                    setMessage(null)
                }} />
            }
        </React.Fragment>
    )
}